import React from 'react';

import If from '../../Shared/If/If';
import { FundNoteAdd, FundNoteBuy } from '../../../settings/settings';

import './NewFundSearch.scss';

const NewFundSearchSuggestionNotes = ({ fund, fundType, scsTier }) => {
  const showIclassMessage = scsTier === 'iClass' && fund.iClass;
  return (
    <div className="new-fund-search-suggestion-note">
      <If test={showIclassMessage}>
        <div className="new-fund-search-note-style">
          <div className="new-fund-search-note-style-min">
            Required: $50,000 fund minimum, per fund
          </div>
        </div>
      </If>
      <If test={fund.notes[FundNoteAdd.OWNED_EXISTING]}>
        <div className="new-fund-search-note-style">
          You're already invested in this {fundType}.
        </div>
      </If>

      <If test={fund.notes[FundNoteAdd.OWNED_NEW]}>
        <div className="new-fund-search-note-style">
          You have already added this {fundType}.
        </div>
      </If>

      <If
        test={
          fund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_NON_IRA] ||
          fund.notes[FundNoteAdd.RETIREMENT_INCOME_FOR_IRA]
        }
      >
        <div className="new-fund-search-note-style">
          {!showIclassMessage && (
            <div className="new-fund-search-note-style-min">
              $25,000 minimum investment.
            </div>
          )}
          All dividends from the {fund.name} fund will be distributed and
          deposited to your most recently added bank on file. Your bank
          selection can be changed later in your account settings. If you do not
          have a bank of file, dividends will be distributed by check to address
          on record.
        </div>
      </If>

      <If test={fund.notes[FundNoteAdd.SUMMIT]}>
        <div className="new-fund-search-note-style">
          $25,000 minimum investment.
        </div>
      </If>

      <If
        test={
          fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_ACTIVE] ||
          fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_FEE_REMOVED] ||
          fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_ACTIVE] ||
          fund.notes[FundNoteBuy.MONEY_MARKET_EVENT_GATE_REMOVED]
        }
      >
        <div
          className="new-fund-search-note-style"
          dangerouslySetInnerHTML={{
            __html: fund.moneyMarketReformMessage,
          }}
        />
      </If>
    </div>
  );
};
export default NewFundSearchSuggestionNotes;
